/* HOPERY Multipack: Packwahl auf der Produktkarte (snippets/hopery-multipack-card.liquid).
   Ein einziger Klick-Listener für die ganze Seite, damit es auch nach Filtern
   und "Mehr laden" funktioniert. Der Warenkorb läuft über das Theme
   (product-card quickAdd liest data-product-id beim Klick). */
document.addEventListener('click', function (evt) {
  var thumb = evt.target.closest && evt.target.closest('.hp-mpc__thumb');
  if (!thumb) return;
  evt.preventDefault();
  var box = thumb.closest('.hp-mpc');
  var card = thumb.closest('product-card');
  if (!box || !card || thumb.classList.contains('is-active')) return;
  var d = thumb.dataset;

  box.querySelectorAll('.hp-mpc__thumb').forEach(function (el) {
    var on = el === thumb;
    el.classList.toggle('is-active', on);
    el.setAttribute('aria-pressed', on ? 'true' : 'false');
  });

  var price = box.querySelector('.hp-mpc__price');
  var tpl = thumb.querySelector('template');
  if (price && tpl) price.innerHTML = tpl.innerHTML;

  var img = card.querySelector('.product-card--featured-image-link .product-primary-image');
  if (img && d.srcset) {
    img.setAttribute('data-srcset', d.srcset);
    img.setAttribute('srcset', d.srcset);
    img.setAttribute('src', d.src);
  }

  if (d.url) {
    card.querySelectorAll('a.product-card--featured-image-link, a.product-card-title').forEach(function (a) {
      a.setAttribute('href', d.url);
    });
  }

  var btn = card.querySelector('.product-card--add-to-cart-button-simple');
  if (btn) {
    var ok = d.available === 'true';
    btn.dataset.productId = d.id;
    btn.disabled = !ok;
    btn.toggleAttribute('disabled', !ok);
    var label = btn.querySelector('.product-card--add-to-cart-text');
    var strings = window.theme && window.theme.variantStrings;
    if (label && strings) label.textContent = ok ? strings.addToCart : strings.soldOut;
  }
});
